// 📌 exportReports.ts
import * as XLSX from 'xlsx';
import { Response, CustomerDetails } from "../../services/edit-users/edit-users.service";

// Export Report 1 (New Users)
export const exportReport1Excel = (report1: Response[]) => {
    const data = report1.map((row) => ({
        "Executive": row.customerExecutive,
        "Taxable Amount": row.taxableAmount?.toFixed(2) || '0.00',
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, "Report1");
    XLSX.writeFile(wb, "SalesReport1.xlsx");
};

// Export Report 2 (Customers)
export const exportReport2Excel = (report2: CustomerDetails[]) => {
    const data = report2.map((row) => ({
        "Executive": row.customerExecutive,
        "Customer Name": row.customerName,
        "Invoiced By":row.invoicedBy,
        "Contact": row.customerNumb,
        "Taxable Amount": row.taxableAmount?.toFixed(2) || '0.00',
    }));

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, "Report2");
    XLSX.writeFile(wb, "SalesReport2.xlsx");
};



